module.exports = __webpack_public_path__ + "static/media/carousel-04.7b75b7a7.png";